/*
 * am-gallery-variant-filter.js (v6)
 * ----------------------------------
 * Scurtaturile „360°" / „Galerie foto", starea lor activa si asezarea barei pe
 * randul thumbnail-urilor. Modelul 3D e slide obisnuit in carusel, detectat in
 * Liquid pe orice produs — nu mai exista cod sau mod separat per produs.
 * Filtrarea pe culoare NU se face aici
 * — media vin deja filtrate de Liquid (snippets/product-gallery-variant-filter.liquid,
 * inclus in sections/main-product.liquid), randate direct in `.l4pr`.
 *
 * V1 (89a7c775/f4a9adab) ascundea slide-uri prin JS peste caruselul deja
 * construit de tema. Trei bug-uri diferite — grila Swiper desincronizata,
 * Fancybox aratand alte culori, contorul „+N” gresit — au aratat ca abordarea
 * era structural fragila. V2 nu mai atinge deloc caruselul: tot ce ramane de
 * facut in JS este navigarea si sincronizarea starii UI.
 *
 * La schimbarea variantei, tema inlocuieste tot `.l4pr-container` cu markup
 * proaspat (assets/custom-async.js, activat de `data-variant-image` pe `.l4pr`,
 * setat de Liquid doar cand produsul are blocuri de culoare) si dispatch-uie
 * evenimentele care re-initializeaza Swiper/Fancybox. Bara si stage-ul 3D sunt
 * in acelasi container inlocuit, deci trebuie re-legate dupa fiecare swap —
 * de-asta ascultam pe `document`, nu pe elemente specifice care dispar la swap.
 */
(function () {
  'use strict';

  /* Sare la un slide anume (1-based). Modelul 3D e slide normal in carusel,
     deci „iesirea" din 3D e pur si simplu next/prev — butoanele „360°" si
     „Galerie foto" sunt doar scurtaturi catre slide-ul 3, respectiv 1. */
  function goToSlide(container, index) {
    var el = container.querySelector('.l4pr .swiper-outer') || container.querySelector('.l4pr');
    var swiper = el && el.swiper;
    if (swiper) {
      /* `slideToLoop` cand caruselul e in mod loop: acolo `slideTo` primeste
         indexul slide-ului clonat, nu pe cel real. */
      if (swiper.params && swiper.params.loop) swiper.slideToLoop(index - 1);
      else swiper.slideTo(index - 1);
      return true;
    }
    /* Fara instanta Swiper (caruselul inca se construieste): thumbnail-ul
       corespunzator face acelasi lucru. */
    var bullet = container.querySelectorAll('.swiper-pagination-bullet')[index - 1];
    if (bullet) { bullet.click(); return true; }
    return false;
  }

  /* Aseaza thumbnail-urile si butoanele pe acelasi rand, ca pe pagina oficiala
     KEF. Se face in JS, nu in Liquid, pentru ca `.swiper-custom-pagination` e
     construita de Swiper la runtime — in markup-ul din Liquid nu exista.
     Idempotent: daca randul exista deja, nu-l reconstruim (evenimentele de
     re-randare pot chema functia de mai multe ori). */
  function placeBarInline(container) {
    var bar = container.querySelector('[data-am-gallery-bar]');
    var pagination = container.querySelector('.swiper-custom-pagination');
    if (!bar || !pagination) return;
    if (bar.parentElement && bar.parentElement.classList.contains('am-gallery-row')) return;

    var row = document.createElement('div');
    row.className = 'am-gallery-row';
    pagination.parentElement.insertBefore(row, pagination);
    row.appendChild(pagination);
    row.appendChild(bar);
  }

  function layoutAll() {
    document.querySelectorAll('.l4pr-container').forEach(placeBarInline);
  }

  /* Pe desktop Shopify ascunde butonul XR nativ, fiindca browserul nu poate
     porni AR direct. Il afisam totusi si il transformam intr-un punct de acces
     la un viewer mare + cod QR pentru telefon. Pe mobil butonul ramane 100%
     nativ Shopify, inclusiv detectia Scene Viewer / Quick Look. */
  var desktopArQuery = window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
  var activeArModal = null;
  var arTrigger = null;
  var mobileArLaunchStarted = false;

  /* Shopify livreaza model-viewer v1.12, care reduce automat rezolutia interna
     pana la 25% cand pagina are frame-uri lente. Pe PDP-urile incarcate de
     scripturi terte cobora masurat la 50%: canvasul ramanea mare in DOM, dar
     cadrul WebGL era randat la jumatate si apoi intins — de aici modelul clar
     pe poster si neclar dupa incarcare. Un singur model este prezent in
     galeria filtrata, deci pastram scala completa fara randari paralele. */
  function forceFullResolutionModelViewer() {
    if (typeof customElements === 'undefined' || !customElements.whenDefined) return;
    customElements.whenDefined('model-viewer').then(function () {
      var ModelViewer = customElements.get('model-viewer') || window.ModelViewerElement;
      if (ModelViewer && typeof ModelViewer.minimumRenderScale !== 'undefined') {
        ModelViewer.minimumRenderScale = 1;
        return;
      }

      /* Shopify infasoara clasa originala intr-un polyfill care nu mosteneste
         membrii statici. Setterul ramane pe constructorul de baza din lantul
         prototipurilor instantei (v1.12: `Ap`), deci il gasim dupa descriptor,
         fara sa depindem de numele minificat al clasei. */
      var element = document.querySelector('model-viewer');
      var prototype = element && Object.getPrototypeOf(element);
      while (prototype) {
        var Constructor = prototype.constructor;
        if (Constructor && Object.getOwnPropertyDescriptor(Constructor, 'minimumRenderScale')) {
          Constructor.minimumRenderScale = 1;
          return;
        }
        prototype = Object.getPrototypeOf(prototype);
      }
    });
  }

  forceFullResolutionModelViewer();

  function isDesktopAr() {
    return desktopArQuery.matches;
  }

  function absoluteUrl(value) {
    value = (value || '').trim();
    if (value.indexOf('//') === 0) return window.location.protocol + value;
    try { return new URL(value, window.location.href).href; }
    catch (error) { return value; }
  }

  function modelJsonFor(button) {
    var id = button && button.getAttribute('data-shopify-model3d-id');
    var scripts = document.querySelectorAll('script[id^="ProductJSON-"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var models = JSON.parse(scripts[i].textContent || '[]');
        for (var j = 0; j < models.length; j++) {
          if (String(models[j].id) === String(id)) return models[j];
        }
      } catch (error) {
        /* Un JSON invalid nu trebuie sa blocheze restul galeriei. */
      }
    }
    return null;
  }

  function getSelectedVariantId() {
    var input = document.querySelector('form[id^="main-product-form-"] [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return input.value;
    return new URL(window.location.href).searchParams.get('variant') || '';
  }

  function buildMobileArUrl() {
    /* Pornim de la URL-ul canonic al produsului, nu de la query-ul paginii:
       eliminam parametri de preview, tracking si QA, iar QR-ul ramane scurt si
       transfera numai varianta aleasa + intentia AR. */
    var url = new URL(window.location.pathname, window.location.origin);
    var variantId = getSelectedVariantId();
    if (variantId) url.searchParams.set('variant', variantId);
    /* In preview, telefonul trebuie sa deschida ACEEASI tema draft. Fara acest
       parametru QR-ul testat pe desktop ajungea pe tema live, unde codul v5 nu
       exista inca, deci se oprea pur si simplu pe pagina produsului. Pe tema
       live parametrul nu este emis. */
    var theme = typeof Shopify !== 'undefined' && Shopify.theme;
    if (theme && theme.id && (theme.role === 'unpublished' || theme.role === 'development')) {
      url.searchParams.set('preview_theme_id', String(theme.id));
    }
    /* Acelasi contract folosit de KEF: hash-ul cere lansarea ShopifyXR imediat
       dupa ce pagina se deschide pe telefon. Varianta ramane explicita, astfel
       incat modelul si finisajul selectat pe desktop sa fie pastrate. */
    url.hash = 'ar-mode';
    return url.href;
  }

  function directChildLink(slide) {
    for (var i = 0; i < slide.children.length; i++) {
      if (slide.children[i].matches('a[data-gallery-thumb]')) return slide.children[i];
    }
    return null;
  }

  function galleryItems(container, xrButton) {
    var slides = container.querySelectorAll('.l4pr li');
    var items = [];
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('swiper-slide-duplicate')) continue;
      var link = directChildLink(slides[i]);
      if (!link) continue;
      var viewer = slides[i].querySelector('.am-model-inline model-viewer');
      var thumb = absoluteUrl(link.getAttribute('data-gallery-thumb'));
      if (viewer) {
        var modelData = modelJsonFor(xrButton);
        var iosSource = '';
        if (modelData && modelData.sources) {
          for (var j = 0; j < modelData.sources.length; j++) {
            if (modelData.sources[j].format === 'usdz') iosSource = absoluteUrl(modelData.sources[j].url);
          }
        }
        items.push({
          type: 'model',
          src: absoluteUrl(viewer.getAttribute('src')),
          iosSrc: iosSource,
          poster: absoluteUrl(viewer.getAttribute('poster')),
          alt: viewer.getAttribute('alt') || xrButton.getAttribute('data-shopify-title') || '',
          thumb: thumb || absoluteUrl(viewer.getAttribute('poster'))
        });
      } else {
        var image = link.querySelector('img');
        items.push({
          type: 'image',
          src: absoluteUrl(link.getAttribute('href') || (image && (image.currentSrc || image.src))),
          alt: (image && image.getAttribute('alt')) || '',
          thumb: thumb || absoluteUrl(image && (image.currentSrc || image.src))
        });
      }
    }
    return items;
  }

  function closeArModal() {
    if (!activeArModal) return;
    activeArModal.remove();
    activeArModal = null;
    document.documentElement.classList.remove('am-ar-open');
    document.body.classList.remove('am-ar-open');
    if (arTrigger) arTrigger.focus();
    arTrigger = null;
  }

  function renderQr(modal, url, attempt) {
    attempt = attempt || 0;
    var target = modal.querySelector('[data-am-ar-qr]');
    if (!target || modal !== activeArModal) return;
    target.setAttribute('data-am-ar-url', url);
    if (window.QRCode) {
      target.innerHTML = '';
      new window.QRCode(target, {
        text: url,
        width: 196,
        height: 196,
        colorDark: '#111111',
        colorLight: '#ffffff',
        correctLevel: window.QRCode.CorrectLevel ? window.QRCode.CorrectLevel.M : undefined
      });
      return;
    }
    if (attempt < 40) {
      setTimeout(function () { renderQr(modal, url, attempt + 1); }, 100);
      return;
    }
    target.innerHTML = '<span>Codul QR nu a putut fi generat.</span>';
  }

  /* Paleta oficiala KEF (assets.kef.com, color-swatch/swatch.css?v=24).
     Shopify nu livreaza o valoare cromatica in datele variantelor AudioMonkey:
     selectorul existent contine doar fotografii. De aceea pastram aici numai
     finisajele produselor KEF cu model 3D si folosim exact culorile/gradientele
     producatorului, nu estimari extrase din imagini. */
  var kefFinishPalettes = {
    'boxe-active-kef-coda-w': {
      'vintage burgundy': 'linear-gradient(315deg, #502827 -25%, #7B5554 100%)',
      'nickel grey': 'linear-gradient(315deg, #AAA196 -25%, #D4CAC0 100%)',
      'dark titanium': 'linear-gradient(315deg, #373737 0%, #656565 100%)',
      'midnight blue': 'linear-gradient(315deg, #18202C -25%, #444C57 100%)',
      'moss green': 'linear-gradient(315deg, #424E49 0%, #75807B 100%)'
    },
    'boxe-active-kef-ls-luxe': {
      'eclipse black': 'linear-gradient(315deg, #6E6B6B 50%, #1E1F1F 50%)',
      'mineral white': 'linear-gradient(315deg, #BFBDBB 50%, #EFF0F1 50%)',
      'dusk titanium': 'linear-gradient(315deg, #E3DAD0 50%, #C7BFB5 50%)'
    },
    'boxe-active-kef-ls60-wireless': {
      'royal blue': 'linear-gradient(315deg, #43577D 0%, #51658A 50%, #10284E 100%)',
      'mineral white': 'linear-gradient(315deg, #FFFFFF 0%, #EDEDEC 59%, #E9E9E9 100%)',
      'titanium grey': 'linear-gradient(315deg, #54504C 0%, #97928E 50%, #B8ACA8 100%)',
      'carbon black': 'linear-gradient(45deg, #7A7A7A 0%, #151E21 100%)'
    },
    'sistem-stereo-hi-fi-kef-ls50-wireless-ii-meta': {
      'titanium grey': 'linear-gradient(315deg, #54504C 0%, #97928E 50%, #B8ACA8 100%)',
      'mineral white': 'linear-gradient(315deg, #FFFFFF 0%, #EDEDEC 59%, #E9E9E9 100%)',
      'carbon black': 'linear-gradient(315deg, #151E21 0%, #3D4346 50%, #636969 100%)',
      'sand shell': 'linear-gradient(315deg, #BFB0A1 0%, #CCC3B6 50%, #DBD2C7 100%)',
      'moss green': 'linear-gradient(315deg, #6A7B6B 0%, #485C49 50%, #334B36 100%)'
    }
  };

  function productHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function normaliseFinish(value) {
    return (value || '').toLowerCase()
      .replace(/\([^)]*\)/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function finishOptions() {
    var palette = kefFinishPalettes[productHandle()];
    if (!palette) return [];
    var selected = String(getSelectedVariantId());
    var seen = {};
    var options = [];
    var labels = document.querySelectorAll('label[for^="option-"][title]');
    for (var i = 0; i < labels.length; i++) {
      if (!labels[i].querySelector('.color-swatch__item, .variant-image')) continue;
      var match = (labels[i].getAttribute('for') || '').match(/^option-(\d+)-/);
      var name = (labels[i].getAttribute('title') || '').trim();
      var paint = palette[normaliseFinish(name)];
      if (!match || !name || !paint || seen[match[1]]) continue;
      seen[match[1]] = true;
      options.push({
        variantId: match[1],
        name: name,
        paint: paint,
        selected: match[1] === selected
      });
    }
    return options;
  }

  function renderFinishSwatches(modal) {
    var section = modal.querySelector('[data-am-ar-finishes]');
    var rail = modal.querySelector('[data-am-ar-finish-swatches]');
    var name = modal.querySelector('[data-am-ar-finish-name]');
    var options = finishOptions();
    if (!section || !rail || !options.length) return;
    rail.innerHTML = '';
    for (var i = 0; i < options.length; i++) {
      var swatch = document.createElement('button');
      swatch.type = 'button';
      swatch.className = 'am-ar-finish-swatch';
      swatch.setAttribute('data-am-ar-variant', options[i].variantId);
      swatch.setAttribute('role', 'radio');
      swatch.setAttribute('aria-checked', String(options[i].selected));
      swatch.setAttribute('aria-label', options[i].name);
      swatch.setAttribute('title', options[i].name);
      swatch.classList.toggle('is-active', options[i].selected);
      var color = document.createElement('span');
      color.style.background = options[i].paint;
      swatch.appendChild(color);
      rail.appendChild(swatch);
      if (options[i].selected) name.textContent = options[i].name;
    }
    if (!name.textContent && options[0]) name.textContent = options[0].name;
    section.hidden = false;
  }

  function switchDesktopFinish(modal, variantId) {
    if (!variantId || String(getSelectedVariantId()) === String(variantId)) return;
    var selector = 'label[for^="option-' + variantId + '-"]';
    var label = document.querySelector(selector);
    if (!label) return;
    modal.classList.add('is-loading');
    label.click();

    (function waitForVariant(attempt) {
      if (modal !== activeArModal) return;
      var urlVariant = new URL(window.location.href).searchParams.get('variant');
      var current = String(urlVariant || getSelectedVariantId());
      var nextButton = document.querySelector('.l4pr-container .am-xr-btn');
      if (current === String(variantId) && nextButton) {
        closeArModal();
        openDesktopAr(nextButton);
        return;
      }
      if (attempt < 80) {
        setTimeout(function () { waitForVariant(attempt + 1); }, 100);
        return;
      }
      modal.classList.remove('is-loading');
    })(0);
  }

  function showArItem(modal, items, index) {
    var item = items[index];
    var stage = modal.querySelector('[data-am-ar-stage]');
    if (!item || !stage) return;
    stage.innerHTML = '';
    if (item.type === 'model') {
      var viewer = document.createElement('model-viewer');
      viewer.setAttribute('src', item.src);
      if (item.iosSrc) viewer.setAttribute('ios-src', item.iosSrc);
      if (item.poster) viewer.setAttribute('poster', item.poster);
      viewer.setAttribute('alt', item.alt);
      viewer.setAttribute('camera-controls', '');
      viewer.setAttribute('auto-rotate', '');
      viewer.setAttribute('shadow-intensity', '1');
      stage.appendChild(viewer);
    } else {
      var image = document.createElement('img');
      image.src = item.src;
      image.alt = item.alt;
      stage.appendChild(image);
    }
    var thumbs = modal.querySelectorAll('[data-am-ar-item]');
    for (var i = 0; i < thumbs.length; i++) {
      var active = parseInt(thumbs[i].getAttribute('data-am-ar-item'), 10) === index;
      thumbs[i].classList.toggle('is-active', active);
      thumbs[i].setAttribute('aria-current', active ? 'true' : 'false');
    }
  }

  function openDesktopAr(button) {
    var container = button.closest('.l4pr-container');
    if (!container) return;
    closeArModal();

    var items = galleryItems(container, button);
    var modelIndex = -1;
    for (var i = 0; i < items.length; i++) {
      if (items[i].type === 'model') { modelIndex = i; break; }
    }
    if (modelIndex < 0) return;

    var modal = document.createElement('div');
    modal.className = 'am-ar-modal';
    modal.innerHTML =
      '<div class="am-ar-dialog" role="dialog" aria-modal="true" aria-labelledby="am-ar-title">' +
        '<button type="button" class="am-ar-close" data-am-ar-close aria-label="Închide">&times;</button>' +
        '<div class="am-ar-stage" data-am-ar-stage></div>' +
        '<aside class="am-ar-panel">' +
          '<span class="am-ar-kicker">REALITATE AUGMENTATĂ</span>' +
          '<h2 id="am-ar-title"></h2>' +
          '<p>Scanați codul QR cu telefonul. La deschiderea paginii, confirmați „Vezi în AR” pentru a porni experiența.</p>' +
          '<div class="am-ar-finishes" data-am-ar-finishes hidden>' +
            '<span class="am-ar-finish-label">CULOARE</span>' +
            '<div class="am-ar-finish-swatches" data-am-ar-finish-swatches role="radiogroup" aria-label="Culoare"></div>' +
            '<strong class="am-ar-finish-name" data-am-ar-finish-name></strong>' +
          '</div>' +
          '<div class="am-ar-qr" data-am-ar-qr aria-label="Cod QR pentru realitate augmentată"></div>' +
          '<p class="am-ar-phone-note">Pe telefon, acceptați mesajul sistemului pentru a vedea produsul în spațiul dvs.</p>' +
          '<div class="am-ar-notes" lang="en">' +
            '<p><span aria-hidden="true">*</span> Actual product colour may differ from the version shown in AR.</p>' +
            '<p><span aria-hidden="true">**</span> Not supported by Chrome on iOS devices.</p>' +
          '</div>' +
        '</aside>' +
        '<nav class="am-ar-thumbs" aria-label="Galerie media"></nav>' +
      '</div>';

    var title = button.getAttribute('data-shopify-title') || 'produsul';
    modal.querySelector('#am-ar-title').textContent = 'Vezi ' + title + ' în spațiul tău';
    var thumbRail = modal.querySelector('.am-ar-thumbs');
    for (var j = 0; j < items.length; j++) {
      var thumbButton = document.createElement('button');
      thumbButton.type = 'button';
      thumbButton.className = 'am-ar-thumb';
      thumbButton.setAttribute('data-am-ar-item', String(j));
      thumbButton.setAttribute('aria-label', items[j].type === 'model' ? 'Model 3D' : 'Imagine ' + (j + 1));
      var thumbImage = document.createElement('img');
      thumbImage.src = items[j].thumb || items[j].poster || items[j].src;
      thumbImage.alt = '';
      thumbButton.appendChild(thumbImage);
      if (items[j].type === 'model') {
        var badge = document.createElement('span');
        badge.textContent = '360°';
        thumbButton.appendChild(badge);
      }
      thumbRail.appendChild(thumbButton);
    }

    document.body.appendChild(modal);
    activeArModal = modal;
    arTrigger = button;
    document.documentElement.classList.add('am-ar-open');
    document.body.classList.add('am-ar-open');
    showArItem(modal, items, modelIndex);
    renderFinishSwatches(modal);
    renderQr(modal, buildMobileArUrl());
    modal.querySelector('.am-ar-close').focus();

    modal.addEventListener('click', function (event) {
      var finishButton = event.target.closest('[data-am-ar-variant]');
      if (finishButton) {
        switchDesktopFinish(modal, finishButton.getAttribute('data-am-ar-variant'));
        return;
      }
      var itemButton = event.target.closest('[data-am-ar-item]');
      if (itemButton) {
        showArItem(modal, items, parseInt(itemButton.getAttribute('data-am-ar-item'), 10));
        return;
      }
      if (event.target.closest('[data-am-ar-close]')) closeArModal();
    });
  }

  function updateDesktopArButtons() {
    var buttons = document.querySelectorAll('.am-xr-btn');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].classList.toggle('am-xr-desktop', isDesktopAr());
      if (isDesktopAr()) buttons[i].setAttribute('aria-haspopup', 'dialog');
      else buttons[i].removeAttribute('aria-haspopup');
    }
    if (!isDesktopAr()) closeArModal();
  }

  function focusMobileArLanding() {
    var url = new URL(window.location.href);
    var arRequested = window.location.hash.indexOf('ar-mode') >= 0 ||
      url.searchParams.get('am_ar') === '1'; /* compatibilitate cu QR-urile v4 */
    if (isDesktopAr() || !arRequested || mobileArLaunchStarted) return;
    mobileArLaunchStarted = true;

    (function launchWhenReady(attempt) {
      var container = document.querySelector('.l4pr-container');
      var shortcut = container && container.querySelector('[data-am-mode="model"][data-am-goto-slide]');
      var button = container && container.querySelector('.am-xr-btn');
      if (container && shortcut) {
        var index = parseInt(shortcut.getAttribute('data-am-goto-slide'), 10);
        if (index > 0) goToSlide(container, index);
      }
      if (container && button) {
        button.classList.add('am-xr-mobile-focus');
        try { button.focus({ preventScroll: true }); }
        catch (error) { button.focus(); }
        container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      /* `launchXR` deschide dialogul nativ iOS/Android. Utilizatorul confirma
         in acel dialog; nu ocolim nicio permisiune a sistemului. */
      reinitShopifyXR();
      if (button && window.ShopifyXR && typeof window.ShopifyXR.launchXR === 'function') {
        var modelId = Number(button.getAttribute('data-shopify-model3d-id'));
        if (modelId) {
          try {
            window.ShopifyXR.launchXR({
              model3dId: modelId,
              title: button.getAttribute('data-shopify-title') || ''
            });
            return;
          } catch (error) {
            /* ShopifyXR poate exista cu o fractiune de secunda inainte ca
               bridge-ul nativ sa fie pregatit; repetam limitat. */
          }
        }
      }

      if (attempt < 50) {
        setTimeout(function () { launchWhenReady(attempt + 1); }, 120);
        return;
      }
      /* Daca dispozitivul nu ofera AR, lasam butonul Shopify nativ vizibil si
         permitem o noua incercare dupa urmatoarea re-randare a produsului. */
      mobileArLaunchStarted = false;
    })(0);
  }

  document.addEventListener('click', function (event) {
    var xrButton = event.target.closest('.am-xr-btn');
    if (!xrButton || !isDesktopAr()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openDesktopAr(xrButton);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && activeArModal) closeArModal();
  });

  if (desktopArQuery.addEventListener) desktopArQuery.addEventListener('change', updateDesktopArButtons);
  else desktopArQuery.addListener(updateDesktopArButtons);

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-am-goto-slide]');
    if (!btn) return;
    var container = btn.closest('.l4pr-container');
    if (!container) return;
    var index = parseInt(btn.getAttribute('data-am-goto-slide'), 10);
    if (index > 0) goToSlide(container, index);
  });

  /* Sincronizeaza starea vizuala cu slide-ul curent — DOUA lucruri pe care
     tema nu le face singura (ambele raportate de Tudor):

     1. `aria-pressed` pe butoanele „360°" / „Galerie foto": butonul modului
        curent trebuie sa arate ca e selectat. De cand butoanele au devenit
        scurtaturi de navigare, nimic nu mai seta atributul.

     2. Linia de sub thumbnail-ul activ: tema o muta la CLICK pe thumbnail
        (custom-async.js), dar nu si cand slide-ul se schimba din sagetile de
        langa poza mare sau prin swipe. Marcam noi bulina activa, dupa
        `swiper.realIndex`, la fiecare schimbare de slide. */
  function syncActiveState(container) {
    var el = container.querySelector('.l4pr .swiper-outer') || container.querySelector('.l4pr');
    var swiper = el && el.swiper;
    if (!swiper) return;
    var current = swiper.realIndex + 1; /* 1-based, ca `data-am-goto-slide` */

    /* Tema muta `.s1lb.label` in afara slide-ului cand construieste Swiper.
       Liquid il randeaza doar pe primul media, dar dupa mutare premiul ramane
       vizibil peste toate imaginile. Legam vizibilitatea badge-ului de indexul
       real al caruselului; functioneaza si dupa swap-ul de varianta. */
    var awards = container.querySelectorAll('.am-award-badge');
    for (var a = 0; a < awards.length; a++) {
      awards[a].hidden = current !== 1;
      awards[a].setAttribute('aria-hidden', String(current !== 1));
    }

    var buttons = container.querySelectorAll('[data-am-goto-slide]');
    for (var i = 0; i < buttons.length; i++) {
      var target = parseInt(buttons[i].getAttribute('data-am-goto-slide'), 10);
      buttons[i].setAttribute('aria-pressed', String(target === current));
    }

    /* Bulinele includ si slide-urile ascunse ale temei, deci mergem pe index,
       nu pe pozitia vizuala. */
    var bullets = container.querySelectorAll('.swiper-pagination-bullet');
    for (var j = 0; j < bullets.length; j++) {
      bullets[j].classList.toggle('swiper-pagination-bullet-active', j === swiper.realIndex);
    }
  }

  function syncAll() {
    document.querySelectorAll('.l4pr-container').forEach(syncActiveState);
  }

  /* `slideChange` acopera sagetile, swipe-ul, clickul pe thumbnail si
     `slideTo` din butoanele noastre — toate trec prin el. Legarea se face pe
     instanta Swiper, care e inlocuita la schimbarea de varianta, deci o
     refacem si dupa fiecare re-randare. */
  function bindSwiperSync(container) {
    var el = container.querySelector('.l4pr .swiper-outer') || container.querySelector('.l4pr');
    var swiper = el && el.swiper;
    if (!swiper || swiper.__amSyncBound) return;
    swiper.on('slideChange', function () { syncActiveState(container); });
    swiper.__amSyncBound = true;
    syncActiveState(container);
  }

  function bindAll() {
    document.querySelectorAll('.l4pr-container').forEach(bindSwiperSync);
    updateDesktopArButtons();
  }

  /* Swiper isi construieste paginatia dupa scriptul temei; incercam pana apare,
     apoi ne oprim. */
  (function waitForPagination(attempt) {
    attempt = attempt || 0;
    if (document.querySelector('.l4pr-container .swiper-custom-pagination')) {
      layoutAll();
      bindAll();
      focusMobileArLanding();
      return;
    }
    if (attempt > 40) return; /* ~6s, apoi lasam bara unde e */
    setTimeout(function () { waitForPagination(attempt + 1); }, 150);
  })(0);

  /* Dupa orice re-randare (schimbare de varianta), markup-ul nou vine din Liquid
     cu bara sub galerie — o re-asezam pe rand cu thumbnail-urile. Paginatia
     poate fi inca in constructie, de-asta asteptam un frame.

     Nu mai resetam niciun mod: caruselul porneste oricum pe featured-ul
     variantei noi, iar modelul e slide obisnuit in el. */
  /* Butonul „Vezi in spatiul tau" e activat de Shopify: `ShopifyXR.setupXRElements()`
     scoate `data-shopify-xr-hidden` de pe butoanele existente. La schimbarea de
     varianta, tema inlocuieste tot `.l4pr-container` si re-initializeaza Swiper
     si Fancybox (custom-async.js:6047-6051), dar NU reapeleaza `loadShopifyXR()`
     — verificat in cod. Butonul nou vine deci cu atributul pus si ramane ascuns
     pe veci. Bug preexistent al temei, nu al galeriei pe culoare: se vede pe
     orice produs cu model 3D si variante. */
  function reinitShopifyXR() {
    if (window.ProductModel && typeof window.ProductModel.loadShopifyXR === 'function') {
      window.ProductModel.loadShopifyXR();
    } else if (window.ShopifyXR && typeof window.ShopifyXR.setupXRElements === 'function') {
      window.ShopifyXR.setupXRElements();
    }
  }

  ['listProductSlider', 'updateSliders', 'fancybox'].forEach(function (evtName) {
    window.addEventListener(evtName, function () {
      requestAnimationFrame(function () {
        layoutAll();
        bindAll();
        focusMobileArLanding();
      });
      reinitShopifyXR();
    });
  });
})();
